
import login from '@/pages/login/index.vue';

export default {
  components: {
    login
  },
  props: {
    tender: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      show: true,
      currentLot: {
        lotNumber: 1,
        awardCriterias: [
          {
            group: 'Price',
            description: 'prijs',
            weight: 1,
            percentage: 1
          },
          {
            group: 'Quality criterion',
            description: 'Kwaliteit',
            weight: 99,
            percentage: 99
          }
        ],
        planningItems: [
          {
            id: 1,
            type: 'PublicationDate',
            name: 'Publicatiedatum',
            date: new Date().toISOString()
          },
          {
            id: 2,
            type: 'ApplicationDeadlineDate',
            name: 'Deadline',
            date: new Date().toISOString()
          }
        ],
        requirements: [
          {
            group: 'Kwaliteiten',
            conditions: ['Aanbesteden', 'formulieren invullen']
          },
          {
            group: 'Expertises',
            conditions: ['Regenboogspotten', 'teddyberen knuffelen']
          }
        ],
        organizations: [
          {
            id: '-',
            name: 'Unicorn Foundation',
            phone: '0912345678',
            email: 'peggle@unicorn.org',
            website: 'www.unicorn-foundation.org',
            contacts: [
              {
                id: '1e8626cb-2704-4b07-a61f-ea548a41b82e',
                name: 'Peggy Peggle',
                phone: '0912345678',
                email: 'peggle@unicorn.org',
                linkedInUrl: null
              }
            ]
          }
        ]
      },
      primaryDocuments: [
        {
          id: 1,
          isPrimary: true,
          fileByteSize: 42000,
          fileName: 'The answer to life, space and everything.',
          filePath:
              'https://www.billhill.com.au/downloader/download/30/42_Answer_to_life_the_universe_and_everything_.pdf',
          extension: '.pdf',
          matches: []
        }
      ],
      documents: [
        {
          id: 2,
          isPrimary: false,
          fileByteSize: Number.MAX_SAFE_INTEGER,
          fileName: 'A deep investigation about tendering',
          filePath: '/nowhere',
          extension: '.txt',
          matches: []
        }
      ]
    };
  },

  computed: {
    price () {
      if (this.tender.price < 10) { return 'Onbekend'; }

      const formattedPrice = this.$options.filters.formatPrice(this.tender.price);

      if (this.tender.price < 500) { return `€${formattedPrice} per uur`; }

      return `€${formattedPrice}`;
    }
  },
  watch: {
    show () {
      if (!this.show) { window.document.body.classList.remove('paywall'); }
    }
  },

  mounted () {
    window.document.body.classList.add('paywall');
  },
  beforeDestroy () {
    window.document.body.classList.remove('paywall');
  }
};
